import { connect } from "react-redux";

import { useEffect, useRef } from "react";
import { store } from "../../../_core/core.Store";
import animateBall from "./Draw.Animation";

interface DrawWinItemInterface {
  isDraw: boolean;
  isBlank?: boolean;
  number: number;
  drawStart: boolean;
  currentTicket: any;
}

/** ORDER: 1.IS DRAWN 2.IS PLACED 3.IS MATCH */
const DrawWinItem = ({
  number,
  isDraw,
  drawStart,
  currentTicket,
}: DrawWinItemInterface) => {
  const previousValue = useRef(null);

  const lStore = store.getState();
  const selectedNumbers = lStore.game.GAMEPLAY.selectedNumbers;

  const onTicketChange = () => {
    let ball: any = document.querySelector(`#DrawWinningNumber${number}`);
    const selectedNumbers = lStore.game.GAMEPLAY.selectedNumbers;

    ball.classList.remove("is-drawn");
    ball.classList.remove("is-placed");
    ball.classList.remove("is-match");
    console.log("ticket change action");
    if (isDraw) {
      //@ts-ignore
      ball.classList.add("is-drawn");
      //@ts-ignore
      ball.classList.add("is-placed");
    }
    if (
      Object.entries(selectedNumbers).length &&
      typeof selectedNumbers[number] !== "undefined"
    ) {
      //@ts-ignore
      ball.classList.add("is-match");
    }
  };

  //check if ticket is changed
  useEffect(() => {
    if (drawStart === previousValue.current) {
      onTicketChange();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTicket]);

  useEffect(() => {
    //@ts-ignore
    previousValue.current = drawStart;
    animateBall(
      document.querySelector(`#DrawWinningNumber${number}`),
      number - 1,
      () => {
        if (
          Object.entries(selectedNumbers).length &&
          typeof selectedNumbers[number] !== "undefined"
        ) {
          //@ts-ignore
          document
            .querySelector(`#DrawWinningNumber${number}`)
            .classList.add("is-match");
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="game-ball-wrapper game-ball-win"
      data-number={number}
      id={`DrawWinningNumber${number}`}
    >
      <span className="game-ball">
        {isDraw && (
          <span
            className={
              "game-ball-number game-ball-number-gradient ng-animate ng-enter ng-enter-active game-ball-match"
            }
          >
            <span className="ng-binding">{number}</span>
            <svg
              className="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <path
                className="checkmark__check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
          </span>
        )}
      </span>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    drawStart: state.game.GAMEPLAY.drawStart,
    currentTicket: state.game.GAMEPLAY.currentTicket,
  };
};

export default connect(mapStateToProps, {})(DrawWinItem);
